export default "__VITE_ASSET__0dhfDOQ$__"